import styled from "styled-components";

export const HistoryRecordEndSectionBox = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 10px;

  @media ${({theme}) => theme.mediaQuery.sAndBelow} {
    flex-grow: 1;
  }
`
